import { ReactNode } from "react";
import { Tooltip } from "antd";
import WhatsappDefaultBackground from "../../assets/images/whatsapp-default-wallpaper.png";
import { V2TemplateListItemDto } from "../../api/v2/templates";
import {
    getDisplayStatus,
    getContentTypes,
    getTypeLabel,
} from "../../pages/templates/v2/templateV2Utils";
import TemplateIconText from "../../assets/icons/template-icons/template-icon-text.png";
import TemplateIconTextButton from "../../assets/icons/template-icons/template-icon-text-button.png";
import TemplateIconMenu from "../../assets/icons/template-icons/template-icon-menu.png";
import TemplateIconImageText from "../../assets/icons/template-icons/template-icon-image-text.png";
import TemplateIconImageTextIcon from "../../assets/icons/template-icons/template-icon-image-text-icon.png";
import "./template-thumb-v2.css";

interface TemplateThumbV2Props {
    item: V2TemplateListItemDto;
    previewText: string;
    onClick: () => void;
    index: number;
    actions?: ReactNode;
}

const TemplateThumbV2 = ({ item, previewText, onClick, index, actions }: TemplateThumbV2Props) => {
    const displayStatus = getDisplayStatus(item);
    const statusLowerCase = String(displayStatus || "").toLowerCase();
    const statusClass = statusLowerCase === "ready" ? "APPROVED" : String(statusLowerCase || "").toUpperCase();
    const types = getContentTypes(item);
    const sentWeek = Number(item?.stats?.sent_week || 0);
    const clicksWeek = Number(item?.stats?.clicks_week || 0);

    const iconSrc = (() => {
        if (types.includes("twilio/list-picker")) return TemplateIconMenu;
        if (types.includes("twilio/call-to-action")) return TemplateIconTextButton;
        if (types.includes("twilio/text")) return TemplateIconText;
        if (types.includes("twilio/carousel")) return TemplateIconImageTextIcon;
        if (types.includes("twilio/card")) {
            const typeLabel = getTypeLabel(item).toLowerCase();
            if (typeLabel.includes("buttons")) return TemplateIconImageTextIcon;
            return TemplateIconImageText;
        }
        return TemplateIconText;
    })();

    return (
        <div
            className="template-thumb-v2-container"
            onClick={onClick}
            style={{ zIndex: Math.max(1, 100 - index) }}
        >
            <div className="template-thumb-v2-icons">
                <div className="row">
                    <Tooltip title={getTypeLabel(item)}>
                        <img src={iconSrc} alt="template type icon" className="template-type-icon" />
                    </Tooltip>
                </div>
            </div>
            <div className={`message-thumb-status ${statusClass}`}>
                {statusLowerCase || "-"}
            </div>
            {actions ? <div className="template-thumb-v2-actions" onClick={(e) => e.stopPropagation()}>{actions}</div> : null}

            <div className="template-thumb-v2-preview-container" style={{ backgroundImage: `url(${WhatsappDefaultBackground})` }}>
                <div className="template-thumb-v2-preview">{previewText || "No preview text"}</div>
            </div>

            <div className="template-thumb-v2-details">
                <div className="template-thumb-v2-headline">
                    <div className="template-thumb-v2-title">
                        <span>{item.title}</span>
                    </div>
                </div>
                <div className="template-thumb-v2-data-container">
                    <div className="left">
                        <div className="template-thumb-v2-data">
                            <span>{sentWeek}</span> Weekly sent
                        </div>
                    </div>
                    <div className="right">
                        <div className="template-thumb-v2-data">
                            <span>{clicksWeek}</span> Weekly clicks
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TemplateThumbV2;
